import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import PopupBasePage from "../../../Components/Base/BasePopup";
import ConeLogisticoFiltroAcessoPartial from "./ConeLogisticoFiltroAcessoPartial";

const ConeLogisticoFiltroPopup = ({ isOpen, onClose }: any) => {
  const [filtroAcesso, setFiltroAcesso] = useState<any>({});
  const [filtroAcessos, setFiltroAcessos] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (isOpen) loadData();
  }, [isOpen]);

  const loadData = async () => {
    try {
      const [resBase, resList] = await Promise.all([
        axios.get("buscaBaseFiltroPorUsuario"),
        axios.get("buscaListaFiltroPorUsuario"),
      ]);

      setFiltroAcesso(resBase.data ?? {});
      setFiltroAcessos(resList.data ?? []);
    } catch {
      enqueueSnackbar("Erro ao carregar dados!", { variant: "error" });
    }
  };

  const save = async () => {
    try {
      document.body.style.cursor = "wait";

      const endpoint = "coneLogisticoUsuarioFiltro";
      const method = filtroAcesso?.id ? axios.put : axios.post;
      await method(endpoint, filtroAcesso);

      await axios.post("coneLogisticoUsuarioFiltros", filtroAcessos);
      await loadData();

      enqueueSnackbar("Salvo com sucesso!", { variant: "success" });
      // onClose(); // se quiser fechar automaticamente
    } catch {
      enqueueSnackbar("Erro ao salvar!", { variant: "error" });
    } finally {
      document.body.style.cursor = "default";
    }
  };

  return (
    <PopupBasePage
      title="Filtro Cone Logístico"
      isOpen={isOpen}
      onClose={onClose}
      onClickFirstButtonPopupCallback={save}
      isPesquisa={true}
      confirmClose
    >
      <div className="container">
        <div className="row">
          <div className="align-all-left col-md-12 order-md-1">
            <ConeLogisticoFiltroAcessoPartial
                coneLogisticoFiltroAcesso={filtroAcesso} 
                coneLogisticoFiltroAcessos={filtroAcessos}
              setConeLogisticoFiltroAcessos={setFiltroAcessos}
            />
          </div>
        </div>
      </div>
    </PopupBasePage>
  );
};

export default ConeLogisticoFiltroPopup;
